(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvMenuBarButton', drvMenuBarButton);

    drvMenuBarButton.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvMenuBarButton
     * 
     * @description
     * Creates a menu bar button, which is populated using transclusion.
     * To be used with drvMenuBar.
     *   
     */
    function drvMenuBarButton() {
        var directive = {
            link: link,
            restrict: 'E',
            transclude: true,
            scope: {
            },
            template:
                '<div><md-menu-item><md-button><ng-transclude></ng-transclude></md-button></md-menu-item></div>'
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }
})();